var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUpRightBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9996 8L24.9996 21C24.9996 21.2652 24.8942 21.5196 24.7067 21.7071C24.5192 21.8946 24.2648 22 23.9996 22C23.7344 22 23.48 21.8946 23.2925 21.7071C23.1049 21.5196 22.9996 21.2652 22.9996 21L22.9996 10.4137L8.70708 24.7075C8.51944 24.8951 8.26494 25.0006 7.99958 25.0006C7.73422 25.0006 7.47972 24.8951 7.29208 24.7075C7.10444 24.5199 6.99902 24.2654 6.99902 24C6.99902 23.7346 7.10444 23.4801 7.29208 23.2925L21.5858 9L10.9996 9C10.7344 9 10.48 8.89464 10.2925 8.70711C10.1049 8.51957 9.99958 8.26522 9.99958 8C9.99958 7.73478 10.1049 7.48043 10.2925 7.29289C10.48 7.10536 10.7344 7 10.9996 7L23.9996 7C24.2648 7 24.5192 7.10536 24.7067 7.29289C24.8942 7.48043 24.9996 7.73478 24.9996 8Z",
    fill: "#F0EAD8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpRightBold);
export default __webpack_public_path__ + "static/media/ArrowUpRightBold.2af0b84287f4a7f863a9bc6ff4eecc3e.svg";
export { ForwardRef as ReactComponent };